import { useQuery } from '@tanstack/react-query'

import { type StripePrice } from 'components/admin/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export function useGetStripePrices () {
  return useQuery<StripePrice[], GrapeAPIErrorType>({
    queryKey: ['stripe-prices'],
    queryFn: async () => {
      const response = await fetchWithHeaders('/api/web/admin/stripe/prices')
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
  })
}
